module.exports = __webpack_public_path__ + "static/sharelinks-and-earn-ba083bb71bc5f681795ed0428c297725.png";